import type {Editor} from "slate";

import useRRv6CheckForUnsavedChanges from "./hooks/use-rrv6-check-for-unsaved-changes.ts";

interface Props {
    editor: Editor | null;
    viewOnly: boolean;
}

export const CheckForUnsavedChangesRRv6 = ({editor, viewOnly}: Props) => {
    useRRv6CheckForUnsavedChanges(editor, viewOnly);
    return <></>;
};
